import { Answer } from '../common/model'

export const sampleAnswers: Answer[] = ["d", "a", "c", "c", "a", "b", "e", "a", "c", "e", "b", "e", "d", "a", "e", "e", "b", "a", "c", "e", "c", "c", "c", "c", "c", "c", "c", "c", "c", "c", "c", "c", "c", "c", "c", "c", "c", "c", "c", "c", "c", "c", "c", "c", "c", "c", "c", "c", "c", "c", "c", "c", "c", "c", "e", "e", "e", "e", "e", "e", "e", "e", "e", "e"]


